import { parseAlgoliaHitSnippet } from "@algolia/autocomplete-preset-algolia";
import { createElement, Fragment, type JSX } from "react";
import { type SnippetResult } from "algoliasearch";

type AaSnippetHitParams<THit> = {
	hit: THit;
	attribute: keyof THit | Array<string | number>;
	tagName?: string;
};

export function AaSnippet<THit extends { _snippetResult?: SnippetResult | undefined }>({
	hit,
	attribute,
	tagName = "mark",
}: AaSnippetHitParams<THit>): JSX.Element {
	return createElement(
		Fragment,
		{},
		parseAlgoliaHitSnippet<THit>({ hit, attribute }).map(({ value, isHighlighted }, index) => {
			if (isHighlighted) {
				return createElement(tagName, { key: index }, value);
			}

			return value;
		})
	);
}
